export const language = {
    languageName: "English",

    app: {
        name: "LRC Maker",
        fullname: "Akari's LRC Maker",
    },

    header: {
        home: "home",
        editor: "editor",
        synchronizer: "synchronizer",
        gist: "Github Gist",
        preferences: "preferences",
    },

    audio: {
        loadAudio: "load audio",
        play: "play",
        pause: "pause",
        replay5s: "replay 5s",
        forward5s: "forward 5s",
        resetRate: "reset playback rate",
        error: [
            "audio error",
            "audio aborted by user",
            "audio network error",
            "audio decoding error",
            "audio not supported",
        ],
    },

    loadAudio: {
        file: "File",
        url: "URL",
        loadFile: "Click here or drop audio file in this page",
    },

    home: {
        tips: "Tips",
        tipForLyricText: "Navigate to the editor page and paste lyric text.",
        tipForUploadAudio: "Click the bottom left button to load audio file.",
        tipForSynchronizer: "Navigate to synchronizer page and make your lrc :)",
        tipTopLeft: "Click here come back to this page",
        tipTopRight: "Click here to navigate to other page",
        tipBottomLeft: "load audio here, and control the audio",
        tipBottomRight: "change the playback rate here",
    },

    editor: {
        metaInfo: "meta info",
        album: "album",
        title: "title",
        artist: "artist",
        uploadText: "upload text",
        copyText: "select all and copy",
        downloadText: "download",
        saveToGist: "save to Github Gist",
        saveFileName: "Filename",
        utils: "lrc utils",
    },

    gist: {
        newTokenTip: "LRC Maker use Github Token to fetch and store data to Github Gist",
        newTokenButton: "Generate a new Github Token",
        newGistTip: "Create a new Gist repository or assign an existing Gist id",
        newGistRepoButton: "Create a new Gist Repository",
        gistIdPlaceholder: "Or assign an existing Gist id",
        info: "info",
        clearTokenAndGist: "Clear token and Gist id",
    },

    preferences: {
        version: "Version",
        commitHash: "Commit hash",
        updateTime: "Update time",
        repo: "Repository",
        help: "Help & tips",
        language: "Language",
        builtInAudio: "Use browser built-in audio player",
        spaceButton: "On-screen space key",
        themeColor: "Theme color",
        lrcFormat: "LRC formtat adjust",
        fixed: "Timestamp fixed",
        leftSpace: "Left space",
        rightSpace: "Right space",
        clearCache: "Clear caches",
        themeMode: {
            label: "Theme Mode",
            auto: "auto",
            light: "light",
            dark: "dark",
        },
    },

    notify: {
        audioLoaded: "Audio loaded.",
    },
};
